import React, {Component} from 'react';
import { array, object, instanceOf } from 'prop-types'

import {connect} from 'react-redux';

//Redux parts
import {bindActionCreators} from 'redux';
import {
  getHomePageWorthStats,
  getLiveAuctions,
  getRecentDeals,
} from '../../actions/homepage';

//Home page source map
import HomePageData from '../../constants/homepage';

//Layout components
import Slider from './slider';
import Section from './section';

//Class components
import HomePageSubmissionForm from './sections/submissionForm';
import FeaturesAndNewsletter from './sections/featuresAndNewsLetter';

//Stateless components
import Navigator from './sections/navigator';
import HowItWork from './sections/howItWork';
import Review from './sections/review';
import AsFeaturedIn from './sections/asFeaturedIn';
import Stat from './sections/stat';
import Commitment from './sections/commitment';
import LiveAuction from './sections/liveAuction';
import RecentDeal from './sections/recentDeal';

//Skeleton components
import RecentDealSkeleton from './skeletons/recentDealSkeleton';
import StatSkeleton from './skeletons/statSkeleton';
import LiveAuctionSkeleton from './skeletons/liveAuctionSkeleton';

class HomePage extends Component {

  constructor(props) {
    super(props);

    this.submissionFormRef = React.createRef();
    this.fireEvent = this.fireEvent.bind(this);
  }

  static propTypes = {
    getHomePageWorthStats: instanceOf(Function),
    getLiveAuctions: instanceOf(Function),
    getRecentDeals: instanceOf(Function),
    liveAuctions: array,
    stat: object
  };

  componentDidMount() {
    this.props.getHomePageWorthStats();
    this.props.getLiveAuctions();
    this.props.getRecentDeals(HomePageData.recentDeals.requestParams)
  }

  renderHowItWorks() {
    return HomePageData.howItWorks.stepPreviewData.map((step) => {
      return (
          <a className='step' href={HomePageData.howItWorks.link}
             key={step.num}>
            <HowItWork step={step} key={step.num}/>
          </a>
      );
    });
  }

  renderLiveAuction() {
    if (this.props.liveAuctions &&
        this.props.liveAuctions instanceof Array
        && this.props.liveAuctions.length) {
      return this.props.liveAuctions.map((auction, key) => {
        return <LiveAuction auction={auction} key={key} onClickEvent={this.fireEvent}/>;
      });
    }
    return null;
  }

  renderStats() {
    if (this.props.stat && (Object.keys(this.props.stat)).length === 3) {
      return HomePageData.stats.records.map((stat, key) => {
        const worthStat = this.props.stat[`${stat.name}_count`];
        const attr = {className: `stat ${stat.name || ''} `};

        return <Stat key={key} stat={stat} worthStat={worthStat} attr={attr}/>;
      });
    }
    return null;
  }

  renderSlider(ComponentTag, records) {
    if(!records) return;

    return records.map(
          (content, key) => <ComponentTag key={key} content={content} onClickEvent={this.fireEvent}/>);
  }

  fireEvent(e){
    e.preventDefault();
    const target = e.currentTarget;
    //redirect to the specific link
    location.href = target.getAttribute('href');
  }

  render() {
    let {
          navigator: {title: navigatorTitle, subtitle: navigatorSubTitle, buttons},
          submissionForm: {title: formTitle, tabs},
          asFeaturedIn: {title: asFeaturedInTitle, quotes},
          howItWorks: {title: hiwTitle, subtitle: hiwSubTitle},
          reviews: {title: reviewTitle, userReviews},
          commitment: {title: commitmentTitle, subtitle: commitmentSubTitle, text: commitmentText},
          featuresAndNewsLetter: {title: featuresAndNewsletterTitle, features, newsletter},
          liveAuction: {title: recentAuctionTitle},
          recentDeals:{title:recentDealsTitle, link:recentDealsLink, label:recentDealLabel, section:recentDealSection}
        }
            = HomePageData,

        howItWorks = this.renderHowItWorks(),
        stats = this.renderStats(),
        liveAuctions = this.renderLiveAuction(),
        reviews = this.renderSlider(Review, userReviews),
        asFeaturedIn = this.renderSlider(AsFeaturedIn, quotes),
        recentDeals = this.renderSlider(RecentDeal, this.props.recentDeals),
        exploreMarketPlaceProps = {
          className: 'explore-market-place',
          href: recentDealsLink,
          onClick: this.fireEvent,
          'data-label': recentDealLabel,
          'data-section': recentDealSection,
        };

    return (
        <div className='homepage'>

          {/*Navigator*/}
          <Section itemClassName={'navigator-wrapper'}>
            <Navigator title={navigatorTitle} subtitle={navigatorSubTitle} buttons={buttons} submissionFormRef={this.submissionFormRef} onClickEvent={this.fireEvent}/>
          </Section>

          {/*Recent Deals*/}
          {recentDeals
          ? <Section itemClassName={'recent-deals-wrapper slider-section'} title={recentDealsTitle}>
             <Slider>{recentDeals}</Slider>
              <a {...exploreMarketPlaceProps}>Explore market place</a>
            </Section>
          : <RecentDealSkeleton/>}

          {/*How It Works*/}
          <Section itemClassName={'how-it-works'} title={hiwTitle}>
            <h4 className='subtitle center' dangerouslySetInnerHTML={ {__html: hiwSubTitle}}/>
            <div className="steps">{howItWorks}</div>
          </Section>

          {/*Reviews*/}
          <Section itemClassName={'slider-section reviews-wrapper'} title={reviewTitle}>
            <Slider>{reviews}</Slider>
          </Section>

          {/*Form*/}
          <Section itemClassName={'home-page-submission-form'} title={formTitle}>
            <HomePageSubmissionForm tabs={tabs} componentRef={this.submissionFormRef} location={this.props.location}/>
          </Section>

          {/*As Featured In*/}
          <Section itemClassName={'slider-section as-feature-in-wrapper'}
                   title={asFeaturedInTitle}>
            <Slider>{asFeaturedIn}</Slider>
          </Section>

          {/*Live auction*/}
          {liveAuctions ? <Section itemClassName={'slider-section'}
                       title={recentAuctionTitle} itemId={'live-auctions'}>
                <Slider>{liveAuctions}</Slider>
              </Section>
              : <LiveAuctionSkeleton/>}

          {/*Stats*/}
          {stats
              ? <Section itemClassName={'stats'}
                       className={'stat-wrapper'}>{stats}</Section>
              : <StatSkeleton/>}

          {/*Commitment*/}
          <Section itemClassName={'commitment'} title={commitmentTitle}>
            <Commitment subtitle={commitmentSubTitle} text={commitmentText}/>
          </Section>

          {/*Features and Newsletters*/}
          <Section itemClassName={'features-and-newsletter'}
                   title={featuresAndNewsletterTitle}
                   id={'features-and-newsletter-section'}>
            <FeaturesAndNewsletter features={features} newsletter={newsletter}/>
          </Section>
        </div>
    );
  }
}

const mapStateToProps = ({Homepage}) => {
  return {
    stat: Homepage && Homepage.stat ? Homepage.stat : null,
    liveAuctions: Homepage && Homepage.liveAuctions ? Homepage.liveAuctions :
        null,
    recentDeals:Homepage && Homepage.recentDeals ? Homepage.recentDeals : null
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({getHomePageWorthStats, getLiveAuctions, getRecentDeals},
      dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);

